import { createTRPCReact } from '@trpc/react-query';

import type { Router } from '@sapling/functions/trpc/server';

export const trpc = createTRPCReact<Router>();
